// extracted by mini-css-extract-plugin
export default {"notificationsWrapper":"styles_notificationsWrapper__3Mdo+","emptyText":"styles_emptyText__ZhJrJ","ringIcon":"styles_ringIcon__7Q57k"};